























import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      dateRange: {},
    };
  },
  props: {
    title: {
      type: String,
      default: "検索範囲:　",
    },
    startPlaceholder: {
      type: String,
      default: "開始日",
    },
    endPlaceholder: {
      type: String,
      default: "終了日",
    },
  },
  mounted() {
    const now = new Date();
    this.dateRange = {
      end: now,
      start: new Date(now.getTime() - 1000 * 3600 * 24 * 30),
    };
  },
  methods: {
    handleOnSearch() {
      this.$emit("search", this.dateRange);
    },
  },
});
